import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { isProdEnv } from '../../services/env'

import OfflineErrorPage from './components/OfflineErrorPage'
import GenericErrorPage from './components/GenericErrorPage'

let logPrefixState = null

/**
 * Wrap a children with error boundary and show a placeholder
 * in case an error happens in the children component.
 */
class ErrorBoundary extends Component {
    constructor(props) {
        super(props)
        const { logPrefix } = props
        logPrefixState = logPrefix
        this.state = { hasError: false }
    }

    static getDerivedStateFromError(error) {
        window.Logger?.log?.(`${
            logPrefixState || 'Critical application error'
        }: ${error.toString()}`, error)
        return { hasError: true }
    }

    componentDidCatch(error, errorInfo) {
        if (!isProdEnv) console.error(error, errorInfo)
    }

    render() {
        const { hasError } = this.state
        if (hasError) {
            const { fallback } = this.props
            if (fallback) {
                return typeof fallback === 'function'
                    ? fallback()
                    : fallback
            }
            if (window.navigator && window.navigator.onLine === false) {
                return (
                    <OfflineErrorPage
                        onOnline={() => {
                            if (window.navigator && window.navigator.onLine === false) return
                            window.location.reload()
                        }}
                    />
                )
            }
            return <GenericErrorPage />
        }

        const { children } = this.props
        return typeof children === 'function'
            ? children()
            : children
    }
}

ErrorBoundary.propTypes = {
    logPrefix: PropTypes.string,
    fallback: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
}

ErrorBoundary.defaultProps = {
    logPrefix: null,
    fallback: null,
    children: null
}

export default ErrorBoundary
